import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      Hello word
    </div>
  );
}

export default App;
